import { render, staticRenderFns } from "./logoSVG.vue?vue&type=template&id=276d7f0d&scoped=true&"
import script from "./logoSVG.vue?vue&type=script&lang=js&"
export * from "./logoSVG.vue?vue&type=script&lang=js&"
import style0 from "./logoSVG.vue?vue&type=style&index=0&id=276d7f0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276d7f0d",
  null
  
)

export default component.exports